@switch (activeConsent()) {
  @case (ConsentType.TERMS_OF_SERVICE) {
    <rs-web-consent-terms-and-conditions
      [legalTexts]="legalTexts()"
      [isLoading]="isConsentSetLoading()"
      (acceptConsent)="acceptConsent($event)"
      (declineConsent)="declineConsent()"
    />
  }
  @case (ConsentType.DATA_PROTECTION) {
    <rs-web-consent-privacy
      [legalTexts]="legalTexts()"
      [isLoading]="isConsentSetLoading()"
      (acceptConsent)="acceptConsent($event)"
    />
  }
  @case (ConsentType.DIGITAL_DOCUMENTS_RECEIVAL) {
    <rs-web-consent-documents
      [legalTexts]="legalTexts()"
      [isLoading]="isConsentSetLoading()"
      (acceptConsent)="acceptConsent($event)"
    />
  }
}
